import { ReactNode } from 'react'
import { Icon } from '@/components/atoms'
import classNames from 'classnames'

export interface ModalProps {
    title: string
    icon?: string
    iconClassName?: string
    isOpen: boolean
    onClose: () => void
    content: (() => ReactNode) | null
    description?: string
}

export const Modal: React.FC<ModalProps> = ({
    title,
    icon,
    iconClassName,
    content,
    isOpen,
    onClose,
    description,
}) => {
    if (!isOpen) return null

    return (
        <div className="fixed inset-0 z-[3000] flex items-center justify-center">
            {/* Overlay */}
            <div className="absolute inset-0 bg-neutral-900 bg-opacity-40"></div>
            <div
                className="relative min-w-minWidgetWidth max-w-lg gap-1 rounded-xxl border border-neutral-200 bg-white shadow-lg"
                role="dialog"
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                {/* Header */}
                <div className="flex items-center justify-between px-6 pb-4 pt-6">
                    <div className="flex items-center gap-1">
                        {icon && (
                            <Icon
                                className={classNames(
                                    'text-error',
                                    iconClassName
                                )}
                                name={icon}
                            />
                        )}
                        <div
                            id="modal-title"
                            className="text-heading-5 font-raleway"
                        >
                            {title}
                        </div>
                    </div>
                    <div>
                        <button
                            className={'text-neutral-500'}
                            onClick={onClose}
                            data-testid="close-button"
                            aria-label="Close modal"
                        >
                            <Icon name="close" size="smedium" />
                        </button>
                    </div>
                </div>

                {/* Container */}
                <div id="modal-description" className="flex flex-col gap-6">
                    {description && (
                        <div className="px-6 text-sm text-neutral-800">
                            {typeof description === 'string' ? (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: description,
                                    }}
                                />
                            ) : (
                                description
                            )}
                        </div>
                    )}
                    {content?.()}
                </div>
            </div>
        </div>
    )
}
